import React from "react";
import styled from "react-emotion";
import { theme, mqMin } from "../../styles/theme";
import { inject, observer } from "mobx-react";
import debounce from "lodash.debounce";
import randomInt from "random-int";
import range from "lodash.range";

const Pic = styled.img`
  width: 100%;
  height: auto;
  position: relative;
  z-index: 3;
  ${mqMin(theme.tablet)} {
    z-index: ${props => props.z};
  }
`;

const PicAbs = styled.img`
  width: 100%;
  height: auto;
  position: absolute;
  z-index: ${props => props.z};
`;

const Heading = styled.h2`
  font-size: ${theme.h3};
  font-family: ${theme.sans.fontFamily};
  font-weight: ${theme.sans.bold};
  line-height: ${theme.lineHeight1};
  margin-top: ${theme.spaceMicro};
`;

const SubHeading = styled.a`
  font-size: ${theme.h5};
  font-family: ${theme.sans.fontFamily};
  font-weight: ${theme.sans.normal};
  line-height: ${theme.lineHeight1};
  background: linear-gradient(
    to top,
    rgba(138, 217, 115, 0.4) 35%,
    transparent 35%
  );
`;

const Text = styled.div`
  font-size: ${theme.h4};
  font-family: ${theme.display.fontFamily};
  font-weight: ${theme.display.fontWeight};
  margin-top: ${theme.space1};
  margin-bottom: ${theme.micro};
  ${mqMin(theme.tablet)} {
    font-size: ${theme.h4};
  }
`;

const progress = (step = 5) => {
  let lastProgress = 0;
  let lastIndex = randomInt(3, 50);
  return progress => {
    if (progress > lastProgress + step || progress < lastProgress - step) {
      lastProgress = progress;
      lastIndex = randomInt(3, 99);
    }
    return lastIndex;
  };
};

const getProgress = range(3).map(x => progress());

const ProfilePic = ({
  scrollingImages,
  profileImage,
  scrolling,
  text,
  heading,
  webpage,
  webpageName,
  progress
}) => {
  return (
    <div style={{ position: "relative", zIndex: 1 }}>
      {scrollingImages.map((s, x) => (
        <PicAbs key={x} z={getProgress[x](progress)} src={s} />
      ))}
      <Pic z={scrolling ? 2 : 100} src={profileImage} />
      <Heading>{heading}</Heading>
      <Text dangerouslySetInnerHTML={{ __html: text }} />
      {webpage &&
      webpageName && <SubHeading href={webpage}>{webpageName}</SubHeading>}
    </div>
  );
};

export default inject(({ store }) => ({
  scrolling: store.uiStore.scroll.scrolling
}))(observer(ProfilePic));



// WEBPACK FOOTER //
// ./src/components/ProfilePic/index.js